<template>
  <span>
    <span v-if="typeof reminder !== 'undefined'">
      <span v-if="!present">
        <el-popover placement="top" width="200" trigger="hover" :content="reminder.description">
          <span slot="reference" v-edit:reminder="reminder" style="cursor: pointer">
            <i class="fa fa-circle" :style="{color: reminder.category.color}"></i>
            <strong>{{ reminder.date.date | moment('DD/MM/YYYY') }}</strong> : {{ reminder.category.name }}
          </span>
        </el-popover>
      </span>

      <span v-if="present === 'description'">
        <span v-if="reminder.description">{{ reminder.description }}</span>
      </span>
    </span>
    <span v-else>
      <pulse-loader color="#cccccc" size="8px"></pulse-loader>
    </span>
  </span>
</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import Customer from './Customer.vue'

  export default {
    name: 'reminder',
    components: {
      Customer,
      PulseLoader
    },
    props: ['present', 'item'],
    computed: {
      reminder () {
        return this.item
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Reminder.vue?903cd238